module.exports = __webpack_public_path__ + "assets/img/fw.a706d4ae.png";